import React from 'react';
import LandingNav from '../components/landing/LandingNav';
import Hero from '../components/landing/Hero';
import WhyBodyDoubling from '../components/landing/WhyBodyDoubling';
import TaskBasedMatching from '../components/landing/TaskBasedMatching';
import Features from '../components/landing/Features';
import DashboardPreview from '../components/landing/DashboardPreview';
import HowItWorks from '../components/landing/HowItWorks';
import Footer from '../components/landing/Footer';
import BugReport from '../components/BugReport';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <LandingNav />
      <Hero />
      <WhyBodyDoubling />
      <TaskBasedMatching />
      <Features />
      <DashboardPreview />
      <HowItWorks />
      <Footer />
      <BugReport />
    </div>
  );
};

export default LandingPage;
